import { NgModule } from '@angular/core';
import { ANGULARTICS2_TOKEN, RouterlessTracking, Angulartics2, Angulartics2OnModule } from 'angulartics2';

import * as ɵngcc0 from '@angular/core';
class Angulartics2RouterlessModule {
    static forRoot(settings = {}) {
        return {
            ngModule: Angulartics2RouterlessModule,
            providers: [
                { provide: ANGULARTICS2_TOKEN, useValue: { settings } },
                RouterlessTracking,
                Angulartics2,
            ],
        };
    }
}
Angulartics2RouterlessModule.ɵfac = function Angulartics2RouterlessModule_Factory(t) { return new (t || Angulartics2RouterlessModule)(); };
Angulartics2RouterlessModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: Angulartics2RouterlessModule });
Angulartics2RouterlessModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[Angulartics2OnModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Angulartics2RouterlessModule, [{
        type: NgModule,
        args: [{
                imports: [Angulartics2OnModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Angulartics2RouterlessModule, { imports: function () { return [Angulartics2OnModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Angulartics2RouterlessModule };

//# sourceMappingURL=angulartics2-routerlessmodule.js.map